let swiperProperty = null;

function initswiperProperty() {
    if (window.innerWidth < 768) {
        if (!swiperProperty) {
            swiperProperty = new Swiper('.property__categories__slider', {
                slidesPerView: 'auto',
                spaceBetween: 0,
                loop: false,
                speed: 800,
                pagination: {
                    el: ".property__categories-pagination",
                    clickable: true,
                },
                autoplay: {
                    delay: 4000, 
                    disableOnInteraction: false,
                },
            });
        }
    } else {
        if (swiperProperty) {
            swiperProperty.destroy(true, true);
            swiperProperty = null;
        }
    }
};

initswiperProperty();
window.addEventListener('resize', initswiperProperty);